<template>
    <section class="container mx-auto pt-16">
        <div class="text-center">
            <div class="clear--sm"></div>
            <h2 class="pb-4">{{ $t('RESET_PASSWORD_RESET') }}</h2>
            <p class="py-1">{{ $t('RESET_PASSWORD_BEFORE_YOU') }}</p>
            <p class="py-1" v-html="$t('RESET_PASSWORD_SO_POP')"></p>
        </div>

        <div class="clear--sm"></div>

        <div class="w-full max-w-xs mx-auto">
            <legacy-email-address-field v-model="email" :validation.sync="formValidations.email"></legacy-email-address-field>
            <div class="text-center">
                <submit-button @click="submitRequestToResetPassword" :processing="formProcessing">
                    {{ $t('FORGOTTEN_PASSWORD_PLEASE_SEND') }}
                </submit-button>
                <div class="clear--md"></div>
                <p>{{ $t('RESET_PASSWORD_DO_NOT_WORRY') }}</p>
                <router-link :to="{ name: 'login' }" class="btn btn--secondary mb-16"
                             v-html="$t('RESET_PASSWORD_BACK')">
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
import PasswordService from '@/services/auth/PasswordService';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import LegacyEmailAddressField from '@/components/forms/fields/LegacyEmailAddressField';

let passwordService = new PasswordService();

export default {
    name: 'ForgottenPassword',
    data() {
        return {
            email: null,
            formValidations: {
                email: false,
            },
            formProcessing: false,
        };
    },
    computed: {
        isAllFormFieldsValid() {
            return !this.$v.$invalid;
        },
    },
    methods: {
        /**
         * Send customer email to backend via api and then go to the password notification page.
         *
         * @returns {void}
         */
        requestToResetPassword() {
            passwordService.requestToResetPassword(this.email)
                .then(() => {
                    this.$router.push({ name: 'reset-password-notification' });
                })
                .finally(() => {
                    this.toggleFormProcessing();
                });
        },

        /**
         * Before sending request to backend delay for 0.5 seconds.
         *
         * @returns {void}
         */
        submitRequestToResetPassword() {
            this.toggleFormProcessing();

            setTimeout(() => {
                this.validateStep();
            }, 1000);
        },

        /**
         * Force required validation message to be visible if user tries to submit an empty form.
         *
         * @returns {void}
         */
        forceRequiredValidationMessagesVisibility() {
            this.toggleFormProcessing();
            this.email = this.email || '';
        },

        /**
         * Validate current step before allowing user to continue with registration process.
         *
         * @returns {void}
         */
        validateStep() {
            this.$v.$touch();

            this.isAllFormFieldsValid ? this.requestToResetPassword() : this.forceRequiredValidationMessagesVisibility();
        },

        /**
         * Toggle the form processing property.
         *
         * @returns {void}
         */
        toggleFormProcessing() {
            this.formProcessing = !this.formProcessing;
        },
    },
    components: {
        SubmitButton,
        LegacyEmailAddressField,
    },
    validations: {
        email: {
            isValid() {
                return this.formValidations.email;
            },
        },
    },
};
</script>
